import { VariableType } from 'json-to-graphql-query';

import { StructureNode } from '@/interfaces/structureNode';
import { EntityResource } from './entity.resource';
import { StructureNodeFilterVariables } from './queryVariables/filters/filters';

/**
 * Resource Struktury użytkowników
 *
 * @export
 * @class StructureResource
 * @extends {EntityResource<StructureNode>}
 */
export class StructureNodeResource extends EntityResource<StructureNode> {
  public getFields = {
    id: true,
    name: true,
    order: true,
    epuap: true,
    data: true,
    isGuided: true,
    isSingle: true,
    typeDescription: true,
    isSchool: true,
    isCollege: true,
    parentId: true,
    bankAccountNumber: true,
    regon: true,
    childrenIds: true
  };

  public listFields = {
    id: true,
    name: true,
    type: true,
    isGuided: true,
    isSchool: true,
    isCollege: true,
    typeDescription: true,
    isSingle: true,
    data: true,
    parentId: true,
    bankAccountNumber: true,
    regon: true,
    childrenIds: true
  };

  protected listVariables = StructureNodeFilterVariables;

  constructor() {
    super({
      entityName: 'structureNode'
    });
  }

  /**
   * Pobiera strukturę po zewnętrznym UID
   *
   * @param {string} uid
   * @returns {Promise<StructureNode>}
   * @memberof StructureNodeResource
   */
  public getByExternalUid(uid: string): Promise<StructureNode> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'String!' },
        structureNodeByExternalUid: {
          __args: { uid: new VariableType('uid') },
          id: true,
          name: true,
          type: true,
          typeDescription: true,
          isGuided: true,
          isSchool: true,
          isCollege: true,
          isSingle: true,
          data: true,
          parentId: true,
          childrenIds: true,
          externalUid: true,
          copyUid: true,
          bankAccountNumber: true,
          parent: {
            id: true,
            name: true,
            type: true,
            typeDescription: true,
            isGuided: true,
            isSchool: true,
            isCollege: true,
            isSingle: true,
            data: true
          }
        }
      }
    });
    return this.query({ query, variables: { uid } }, 'structureNodeByExternalUid');
  }

  /**
   * Aktualizuje samodzielność jednostki
   *
   * @param {number} id
   * @param {boolean} isSingle
   * @returns {Promise<number>}
   * @memberof StructureNodeResource
   */
  public updateIsSingle(id: number, isSingle: boolean): Promise<number> {
    const query = this.prepareOptions({
      query: {
        __variables: { id: 'Int!', isSingle: 'Boolean!' },
        structureNodeUpdateIsSingle: {
          __args: { id: new VariableType('id'), isSingle: new VariableType('isSingle') }
        }
      }
    });
    return this.query({ query, variables: { id, isSingle } }, 'structureNodeUpdateIsSingle');
  }

  /**
   * Import jednostek oświatowych
   *
   * @returns {Promise<boolean>}
   * @memberof StructureNodeResource
   */
  public import(): Promise<boolean> {
    const mutation = this.prepareOptions({ mutation: { structureNodeImport: {} } });
    return this.mutation({ mutation }, 'structureNodeImport');
  }
}

export const structureNodeResource = new StructureNodeResource();
